import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, mergeMap, of, switchMap } from 'rxjs';

import { MainProfileService } from '@offconon/core-api';
import { ErrorService } from '@offconon/shared/utils/services/error';

import * as searchSettingsActions from './search-settings.actions';

@Injectable()
export class SearchSettingsEffects {
  private mainProfileService = inject(MainProfileService);

  private actions$ = inject(Actions);
  private errorService = inject(ErrorService);

  loadMenuPointSettings$ = createEffect(() =>
    this.actions$.pipe(
      ofType(searchSettingsActions.fetchMenuSettingList),

      mergeMap(() =>
        this.mainProfileService.mainProfileMainProfileCommunityApplicationSettingsRetrieve().pipe(
          switchMap((menuSettings: any) =>
            of(
              searchSettingsActions.fetchMenuSettingListSuccess({
                menuSettings: menuSettings.results,
              }),
            ),
          ),
        ),
      ),
    ),
  );

  editMenuPointSettings$ = createEffect(() =>
    this.actions$.pipe(
      ofType(searchSettingsActions.editMenuSetting),

      mergeMap((action) =>
        this.mainProfileService
          .mainProfileMainProfileCommunityApplicationSettingsCreate(action.menuSetting)
          .pipe(
            switchMap(() =>
              of(
                searchSettingsActions.setLoaded({ loaded: false }),
                searchSettingsActions.editMenuSettingSuccess({
                  menuSetting: action.menuSetting,
                }),
                searchSettingsActions.setLoaded({ loaded: true }),
              ),
            ),
            catchError((error) => {
              this.errorService.showErrorMessage(error);

              return of();
            }),
          ),
      ),
    ),
  );
}
